import { onMounted, onUnmounted } from 'vue'
import { useAnalytics } from './useAnalytics'

export function useSectionTracking() {
  const analytics = useAnalytics()
  let observer: IntersectionObserver | null = null

  const trackSectionView = (_: string, sectionName: string) => {
    // Only track as an event, not as a page view
    analytics.trackEvent({
      action: 'section_view',
      category: 'engagement',
      label: sectionName,
      value: 1
    })
  }

  onMounted(() => {
    // Create intersection observer to track section views
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id
          const sectionName = entry.target.getAttribute('data-section-name') || sectionId
          trackSectionView(sectionId, sectionName)
        }
      })
    }, {
      threshold: 0.5, // Trigger when 50% of section is visible
      rootMargin: '-10% 0px -10% 0px' // Trigger slightly before section is fully in view
    })

    // Observe all sections
    const sections = document.querySelectorAll('section[id]')
    sections.forEach((section) => {
      observer?.observe(section)
    })
  })

  onUnmounted(() => {
    if (observer) {
      observer.disconnect()
    }
  })

  return {
    trackSectionView
  }
} 